import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { ActivatedRoute, Router , RouterModule  } from '@angular/router';
import { Location } from '@angular/common';
import { PaperlessService } from '../../../../../../_services/_iam/paperless.service';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { PaperlessDataService } from '../../../../../../_services/data-services/paperless-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-paperless-enrollement',
  templateUrl: './paperless-enrollement.component.html',
})
export class PaperlessEnrollementComponent implements OnInit {
  isPaperless: boolean;
  showMessage: boolean;
  isAcmic: boolean;
  chkAcceptTerms = 'disabled';
  enrollPolicyId = '';
  policyDetails: any;
  loading = true;

  constructor(
    private acmicService: AcmicService,
    private paperlessService: PaperlessService,
    private policyDataService: PolicyDataService,
    private route: ActivatedRoute,
    private location: Location,
    private paperlessDataService: PaperlessDataService,
    private router: Router
  ) {}

  onShowMessage() {
    this.showMessage = true;
  }

  closeModal() {
    this.showMessage = false;
  }
  goTopaperless() {
    this.router.navigate(['/billing/paperless']);
  }

  callEnrolldata(policyDetails, where) {
    if (this.chkAcceptTerms === 'enabled') {
      this.paperlessDataService.enroll(policyDetails, where);
    }
  }
  checkValue() {
    if (this.chkAcceptTerms === 'disabled') {
      this.chkAcceptTerms = 'enabled';
    } else {
      this.chkAcceptTerms = 'disabled';
    }
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();

    this.loading = true;

    this.paperlessService.setCurrentRoute('');

    this.enrollPolicyId = this.route.snapshot.paramMap.get('policyid');
    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      this.policyDetails = policyResponse;
    });
    this.loading = false;
  }
}
